import { render, staticRenderFns } from "./jp.vue?vue&type=template&id=66337c30&scoped=true"
import script from "./jp.vue?vue&type=script&lang=js"
export * from "./jp.vue?vue&type=script&lang=js"
import style0 from "./jp.vue?vue&type=style&index=0&id=66337c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66337c30",
  null
  
)

export default component.exports